module.exports = __webpack_public_path__ + "static/media/callesdeoaxaca-large.4f691b05.jpg";